<template>
  <div v-show="visible">
    <div class="mask"></div>
    <div class="scTk clearfix ggtk qxsc">
      <a href="javascript:void(0)" class="xx" @click="closeDialog"></a>
      <div class="ttit pt30">是否取消收藏</div>
      <div class="subtit">&nbsp;</div>
      <div class="hbox clearfix">
        <a href="javascript:void(0)" class="btn" @click="cancelCollect">确 定</a>
        <a href="javascript:void(0)" class="btn02" @click="closeDialog">取 消</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cancelCollectDia",
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    cancelCollect(){
      this.$emit('cancelCollect')
    },
    closeDialog(){
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>

</style>
